<template>
  <el-container>

    <el-row :gutter="10">
      <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="8">
    
              <el-form :inline="true" class="elform-operate-control" size="mini">
                <el-form-item>
                  <el-button type="default" icon="el-icon-s-fold" @click="collapseHTree"></el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-edit" @click="addOpenWin">新增</el-button>
                </el-form-item>
                <!-- <el-form-item>
                  <el-button type="primary" icon="el-icon-download" @click="exportList()">导出</el-button>
                </el-form-item> -->
                <el-form-item>
                  <el-button type="primary" @click="insyncCards">同步</el-button>
                </el-form-item>
                <el-form-item>
                  <el-dropdown @command="handleSetCommand" trigger="click">
                    <span class="el-dropdown-link">
                      <el-button type="primary">设置<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="allocate">分配卡</el-dropdown-item>
                      <el-dropdown-item command="active">激活</el-dropdown-item>
                      <el-dropdown-item command="deactivate">停机</el-dropdown-item>
                      <el-dropdown-item command="tag1">标签1</el-dropdown-item>
                      <el-dropdown-item command="tag2">标签2</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="renewalPkgDia">续费</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="default" @click="removeSim(0)">删除</el-button>
                </el-form-item>
                <el-form-item>
                  <div class="static-total-records">总数：{{ pagging.records_total }}</div>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="16">

              <el-form :inline="true" size="mini">
                <el-form-item label="关键词">
                  <el-input v-model="formInline.key" placeholder="ICCID号/SIM卡号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="formInline.include_children">包含下级数据</el-checkbox>
                </el-form-item>
                <el-form-item label="卡状态">
                  <el-dropdown size="small" type="default" @command="handleFilterStatus">
                    <el-button type="default">
                      {{filter_status}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="item in status_options" :command="item">{{item.label}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item label="卡源">
                    <select v-model="formInline.source_id" class="fm-select-control">
                        <option value="0">全部</option>
                        <option v-for="item in source_options" :value="item.value">{{item.label}}</option>
                    </select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="handleCurrentChange(1)">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="openBatchSearch">批量搜索</el-button>
                </el-form-item>
              </el-form>

            </el-col>
          </el-row>

          <el-dialog
            width="550px"
            title="批量搜索"
            :visible.sync="batchSearchDialogVisible"
            :center="true">
            <div>
              请输入ICCID号，多个ICCID号之间以英文逗号分隔，单次最多输入1000个
            </div>
            <el-form ref="form">
              <el-form-item>
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 10, maxRows: 30}"
                  placeholder="输入ICCID号列表，用逗号','或换行符隔开"
                  v-model="inputMultiple">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="success" @click="batchSearch" size="mini">搜索</el-button>
                <el-button @click="batchSearchDialogVisible = false" size="mini">关闭</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>

          <el-dialog width="550px" title="设置标签1" :visible.sync="tag1DialogVisible" :center="true">
            <el-form ref="formTag1">
              <el-form-item>
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 10, maxRows: 30}"
                  placeholder="输入ICCID号列表，用逗号','或换行符隔开"
                  v-model="inputMultiple">
                </el-input>
              </el-form-item>
              <el-form-item label="标签1">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  placeholder="请输入标签，留空则设置为空"
                  v-model="tag1Value">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="success" @click="batchSetTag1" size="mini">设置</el-button>
                <el-button @click="tag1DialogVisible = false" size="mini">关闭</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>

          <el-dialog width="550px" title="设置标签2" :visible.sync="tag2DialogVisible" :center="true">
            <el-form ref="formTag2">
              <el-form-item>
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 10, maxRows: 30}"
                  placeholder="输入ICCID号列表，用逗号','或换行符隔开"
                  v-model="inputMultiple">
                </el-input>
              </el-form-item>
              <el-form-item label="标签2">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  placeholder="请输入标签，留空则设置为空"
                  v-model="tag2Value">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="success" @click="batchSetTag2" size="mini">设置</el-button>
                <el-button @click="tag2DialogVisible = false" size="mini">关闭</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>

          <div class="sanmuui-body-container">
            <div class="sanmuui-body-left" v-show="displayHTreeVisible">
              <div class="tree-divBox">
                  <el-tree 
                      :data="holdTreeData" 
                      :props="defaultProps" 
                      default-expand-all 
                      ref="getTreeInstance" 
                  @node-click="handleNodeClick"></el-tree>
              </div>
            </div>
            <div class="sanmuui-body-right">
              <el-table
                id="tbGridView"
                ref="getTableInstance"
                :data="tableData"
                :height="tableViewHeight"
                v-loading="loadingTableData"
                @selection-change="handleSelectionChange"
                @row-click="openCardDetailDrawer"
                size="small"
                border
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="iccid"
                  label="ICCID号"
                  width="160">
                </el-table-column>
                <el-table-column
                  prop="sim"
                  label="SIM卡号"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="imsi"
                  label="IMSI号"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="source_name"
                  label="卡源"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="card_type_text"
                  label="卡片类型"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="package_name"
                  label="套餐"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="hold_name"
                  label="所属用户"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="status_text"
                  label="状态"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="amount_usage"
                  label="周期总流量(MB)"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="month_usage"
                  label="当月流量(MB)"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="flowleft_time"
                  label="同步时间"
                  :formatter="formatFlowTime"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="tag1"
                  label="标签1"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="tag2"
                  label="标签2"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="renewal"
                  label="续费记录"
                  width="120">
                    <template slot-scope="scope">
                      <el-link type="primary" @click="modifySimWin(scope.row.sim_id)">{{scope.row.renewal_money}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column
                  prop="first_active_time"
                  label="激活时间"
                  :formatter="formatActiveTime"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="expire_time"
                  label="到期日期"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="operator"
                  fixed="right"
                  label="操作"
                  width="200">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="modifySimWin(scope.row.sim_id)">编辑</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="removeSim(scope.row.sim_id)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <div class="dv-pagging-container">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="pagging.pager_size"
                  :pager-count="pagging.pager_count"
                  :total="pagging.records_total"
                  :current-page="pagging.current_page">
                </el-pagination>
              </div>

            </div>
          </div>
      </el-col>
    </el-row>

    <!-- 新增/修改资料 -->
    <el-dialog :title="dialogTitle" 
      :visible.sync="dialogFormVisible" 
      width="860px" 
      :body-style="{ 
        maxHeight: 'none', 
        overflowY: 'visible' 
      }">
        <el-form :inline="true" :gutter="5" :model="formSimInfo" :rules="rules_formsim" ref="formSimInfo" size="small" style="height: 320px;">
          <el-col :span="12">
            <el-form-item label="所属用户/组织" :label-width="formLabelWidth" prop="hold_name">
              <el-input v-model="formSimInfo.hold_name" autocomplete="off" :disabled="true" class="fm2-input-text-wth"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运营商" :label-width="formLabelWidth" prop="card_type">
              <el-dropdown size="small" type="default" @command="handleSelectOperatorType">
                <el-button type="default">
                  {{formSimInfo.operator_type_text}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in operator_type_options" :command="item">{{item.label}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-link class="in-sync-b" type="primary" @click="InsyncSingleCard">同步卡数据</el-link>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡片类型" :label-width="formLabelWidth" prop="card_type">
              <el-dropdown size="small" type="default" @command="handleSelectCardType">
                <el-button type="default">
                  {{formSimInfo.card_type_text}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in card_type_options" :command="item">{{item.label}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="ICCID号" :label-width="formLabelWidth" prop="iccid">
              <el-input v-model="formSimInfo.iccid" autocomplete="off" placeholder="请输入ICCID" class="fm2-input-text-wth"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="SIM卡号" :label-width="formLabelWidth" prop="sim">
              <el-input v-model="formSimInfo.sim" autocomplete="off" placeholder="请输入设备名称" class="fm2-input-text-wth"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="套餐" :label-width="formLabelWidth">
              <el-dropdown size="small" type="default" @command="handleSelectPackage">
                <el-button type="default">
                  {{formSimInfo.package_text}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in package_options" :command="item">{{item.label}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡源" :label-width="formLabelWidth">
              <el-dropdown size="small" type="default" @command="handleSelectSource">
                <el-button type="default">
                  {{formSimInfo.source_text}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in source_options" :command="item">{{item.label}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="IMSI号" :label-width="formLabelWidth" prop="imsi">
              <el-input v-model="formSimInfo.imsi" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="静默期" :label-width="formLabelWidth" prop="quiet_period">
              <el-input v-model="formSimInfo.quiet_period" autocomplete="off" class="fm2-input-text-wth">
                <template slot="append">月</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出库日期" :label-width="formLabelWidth" prop="shipped_date">
              <el-date-picker
                v-model="formSimInfo.shipped_date"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
              <el-input type="textarea" v-model="formSimInfo.remark" style="width: 480px; height: 120px;"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="addSimInfo('formSimInfo')" :disabled="saveBtnDisableds[0]" size="small">确 定</el-button>
        </div>
    </el-dialog>

     <!-- 分配/迁移卡 -->
     <el-dialog title="分配卡" :visible.sync="allocateDialogVisible" width="500px" :center="true">
        <el-form :model="formAllocate" ref="formAllocate" label-width="110px" class="demo-form-inline" size="small">
            <el-form-item label="ICCID号">
                <el-input v-model="formAllocate.iccid" autocomplete="off" :disabled="true" class="fm2-input-text-wth"></el-input>
            </el-form-item>
            <el-form-item label="请选择新用户" prop="parent">
                <el-input v-model="formAllocate.newHoldName" autocomplete="off" :disabled="true" class="fm2-input-text-wth"></el-input>
            </el-form-item>
            <el-form-item>
                <div class="tree-divBox">
                    <el-tree 
                        :data="holdTreeData" 
                        :props="defaultProps" 
                        default-expand-all 
                        ref="getTreeInstance" 
                    @node-click="handleAllocateNodeClick"></el-tree>
                </div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="allocateDialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="submitAllocate()" :disabled="saveBtnDisableds[2]" size="small">提 交</el-button>
        </div>
    </el-dialog>

    <el-drawer
      title="卡详情"
      :visible.sync="drawer"
      :with-header="false"
      :direction="direction">
      <div class="dr-container">
        <el-tabs v-model="drActiveName" @tab-click="handleDrTabClick">
          <el-tab-pane label="卡详情" name="detail">
            <div class="dr-card-detail">
              <el-row>
                <el-col :span="12"><div class="dr-card-label">ICCID号</div></el-col>
                <el-col :span="12"><div class="dr-card-label">套餐</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="12">{{this.simCardDetailForm.iccid}}</el-col>
                <el-col :span="12">{{this.simCardDetailForm.package}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="12"><div class="dr-card-label">运营商</div></el-col>
                <el-col :span="12"><div class="dr-card-label">卡片类型</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="12">{{this.simCardDetailForm.operator_type}}</el-col>
                <el-col :span="12">{{this.simCardDetailForm.card_type}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="12"><div class="dr-card-label">IMSI号</div></el-col>
                <el-col :span="12"><div class="dr-card-label">Msisdn号</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="12">{{this.simCardDetailForm.imsi}}</el-col>
                <el-col :span="12">{{this.simCardDetailForm.sim}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="12"><div class="dr-card-label">状态</div></el-col>
                <el-col :span="12"><div class="dr-card-label">激活时间</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="12">{{this.simCardDetailForm.status}}</el-col>
                <el-col :span="12">{{this.simCardDetailForm.active_time}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="12"><div class="dr-card-label">到期时间</div></el-col>
                <el-col :span="12"><div class="dr-card-label">静默期(月)</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="12">{{this.simCardDetailForm.expired_time}}</el-col>
                <el-col :span="12">{{this.simCardDetailForm.quiet_period}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="12"><div class="dr-card-label">实名类型</div></el-col>
                <el-col :span="12"><div class="dr-card-label">实名状态</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="12">{{this.simCardDetailForm.realName_type}}</el-col>
                <el-col :span="12">{{this.simCardDetailForm.realName_status}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="12"><div class="dr-card-label">当月流量</div></el-col>
                <el-col :span="12"><div class="dr-card-label"></div></el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div ref="pieChart" style="width: 400px; height: 300px;"></div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="续购套餐" name="renewal-pkg">
            <div>
              <h3>可续套餐</h3>
            </div>
            <el-table
              :data="renewablePkgTable"
              border
              style="width: 100%">
              <el-table-column
                prop="pkgNameCustom"
                label="套餐名称"
                width="200">
              </el-table-column>
              <el-table-column
                prop="pkgTypeStr"
                label="套餐类型"
                width="100">
              </el-table-column>
              <el-table-column
                prop="flowGear"
                label="流量挡位(MB)"
                width="120">
              </el-table-column>
              <el-table-column
                prop="pkgValidity"
                label="有效时长(月)"
                width="80">
              </el-table-column>
              <el-table-column
                label="续购"
                width="80">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="rechargePkg(scope.row.id, scope.row.pkgNameCustom, scope.row.terminalPrice)">充值</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div>
              <h3>已购套餐</h3>
            </div>
            <el-table
              :data="purchasedPkgTable"
              border
              style="width: 100%">
              <el-table-column
                prop="pkg"
                label="套餐名称"
                width="200">
              </el-table-column>
              <el-table-column
                prop="pkgTypeStr"
                label="套餐类型"
                width="100">
              </el-table-column>
              <el-table-column
                prop="gprsTotal"
                label="总流量(MB)"
                width="120">
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="续购时间"
                width="150">
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="下行日志" name="logs">下行日志</el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>

    <el-dialog
      width="500px"
      title="充值续费"
      :visible.sync="renewalsDialogVisible"
      :center="true">
      <el-form ref="formRenwals" label-width="80px">
        <el-form-item label="ICCID号">
          <el-input
            type="textarea"
            :autosize="{ minRows: 10, maxRows: 30}"
            v-model="formRenwals.iccids"
            :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="选择套餐">
          <el-radio-group v-model="formRenwals.radioPkg">
            <el-radio v-for="item in purchasedPkgItems" :label="item.value">{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="金额">
          <label>￥{{ formRenwals.amount }}</label>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-radio-group v-model="formRenwals.radioPaytype">
            <el-radio :label="1">支付宝</el-radio>
            <el-radio :label="2">微信</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="handleRenewal">充值</el-button>
          <el-button @click="renewalsDialogVisible = false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-container>
</template>

<script>
import Api from '../../api/index'
import * as echarts from 'echarts'

export default {
  name: 'sim_manage',
  data() {
    var checkCardType = (rule, value, callback) => {
      setTimeout(() => {
        if (parseInt(value) < 1) {
            callback(new Error('请选择卡类型'));
          } else {
            callback();
          }
      }, 800);
    };
    return {
      dialogFormVisible: false,
      batchSearchDialogVisible: false,
      allocateDialogVisible: false,
      tag1DialogVisible: false,
      tag2DialogVisible: false,
      drawer: false,
      direction: 'rtl',  // Drawer 抽屉: 从右往左开
      drActiveName: 'detail',
      chartInstance: null,  // 存储图表实例，便于后续更新或销毁
      formLabelWidth: '120px',
      selectHoldId: 0,
      selectedHoldName: "",
      activeName: "first",
      textareaSN: "",
      displayUpICCIDControl: true,
      importSNSuccess: 0,
      importSNFailList: "",
      displayUpExcelControl: false,
      importSNSuccess2: 0,
      importSNFailList2: "",
      displayHTreeVisible: true,
      formInline: {
        hold_id: 0,
        include_children: true,
        key: '',
        status: '',
        batch_field: '',
        batch_iccid: [],
        page_index: 1,
        page_size: 20,
        sort_field: '',
        sort_type: ''
      },
      operator_type_options: [],
      card_type_options: [],
      status_options: [],
      package_options: [],
      source_options: [],
      pkg_list: [],
      source_list: [],
      filter_status: "全部",
      tableViewHeight: 600,
      loadingTableData: false,
      selectHoldId: 0,
      selectedHoldName: "",
      holdTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableData: [],
      multipleSelection: [],
      inputMultiple: "",
      pagging: {
        records_total: 3,
        pager_count: 5,
        pager_size: 20,
        current_page: 1
      },
      saveBtnDisableds: [
        false, false, false, false
      ],
      dialogTitle: "新增卡信息",
      rules_formsim: {
        iccid: [
          { required: true, message: '请输入ICCID号', trigger: 'blur' }
        ],
        sim: [
          { required: true, message: '请输入SIM卡号', trigger: 'blur' }
        ],
        card_type: [
          { validator: checkCardType, trigger: 'blur' }
        ]
      },
      formSimInfo: {
        sim_id: 0,
        iccid: "",
        sim: "",
        operator_type: 0,
        operator_type_text: "请选择",
        card_type: 0,
        card_type_text: "请选择",
        hold_id: 0,
        hold_name: "",
        package_id: null,
        package_text: "请选择",
        imsi: null,
        source_id: null,
        source_text: "请选择",
        quiet_period: null,
        shipped_date: null,
        remark: null
      },
      simCardDetailForm: {
        sim_id: 0,
        iccid: "",
        sim: "",
        imsi: "",
        source_id: 0,
        operator_type: "",
        card_type: "",
        package: "",
        quiet_period: "",
        shipped_date: "",
        remark: "",
        status: "",
        active_time: "",
        expired_time: "",
        realName_type: "",
        realName_status: "",
        month_usage: 0,
        amount_usage: 0
      },
      formAllocate: {
        iccid: "",
        newHoldName: "",
        sim_ids: [],
        to_hold_id: 0
      },
      renewablePkgTable: [],
      purchasedPkgTable: [],
      renewalsDialogVisible: false,
      purchasedPkgItems: [],
      formRenwals: {
        sim_ids: [],
        iccids: "",
        radioPkg: 0,
        radioPaytype: 1,
        amount: 10
      },
      tag1Value: "",
      tag2Value: ""
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pagging.current_page = val;
      this.SearchSimList();
    },
    changeImportControlType: function(val) {
      if(val == '1') {
        this.displayUpICCIDControl = true;
        this.displayUpExcelControl = false;
      } else if (val == '2') {
        this.displayUpICCIDControl = false;
        this.displayUpExcelControl = true;
      }
    },
    handleSetCommand: function(command) {
      if(command === "allocate") {
        // 分配卡
        this.allocate();
      } else if(command === "active") {
        // 激活
        this.activeCard();
      } else if(command === "deactivate") {
        // 停机
        this.deactivateCard();
      } else if(command === "tag1") {
        // 标签1
        this.inputMultiple = "";
        this.tag1DialogVisible = true;
        if(this.multipleSelection.length > 0) {
          var setters = [];
          this.multipleSelection.forEach(s => {
            setters.push(s.iccid);
          });
          this.inputMultiple = setters.join("\n");
        }
      } else if(command === "tag2") {
        // 标签2
        this.inputMultiple = "";
        this.tag2DialogVisible = true;
        if(this.multipleSelection.length > 0) {
          var setters = [];
          this.multipleSelection.forEach(s => {
            setters.push(s.iccid);
          });
          this.inputMultiple = setters.join("\n");
        }
      }
    },
    formatFlowTime(row, column) {
      return row.flowleft_time ? row.flowleft_time.replace('T', ' ').substring(0, 19) : "";
    },
    formatActiveTime(row, column) {
      return row.first_active_time ? row.first_active_time.replace('T', ' ').substring(0, 19) : "";
    },
    /**
     * 将字符串以逗号或换行符分割成数组
     * @param {string} str - 要分割的字符串
     * @returns {Array} 分割后的数组
     */
    splitByCommaOrNewline: function(str) {
      // 使用正则表达式匹配逗号或换行符（包括Windows和Unix风格的换行符）
      return str.split(/[,|\r\n|\n|\r]+/)
        // 过滤掉空字符串
        .filter(item => item.trim() !== '');
    },
    collapseHTree: function() {
      if(this.displayHTreeVisible) {
        this.displayHTreeVisible = false;
      } else {
        this.displayHTreeVisible = true;
      }
    },
    loadHoldTree: function(){
      Api.GetHoldTree({}).then(res => {
        if(!res)
          return;

        if(res.code !== 200)
          return;

        this.holdTreeData = res.data;

        // 初始化选中的用户id
        this.selectHoldId = this.holdTreeData[0].id;
        this.selectedHoldName = this.holdTreeData[0].label;
      });
    },
    loadDictionOptions: function() {
      var multipleIds = "1,2,3";
      Api.GetDetailMultipleItems({ dict_ids: multipleIds }).then(res => {
        if(res && res.code === 200) {
          if(res.data) {
            res.data.forEach(element => {
              if(element.dict_id === 1) {
                this.operator_type_options = element.options;
              } else if(element.dict_id === 2) {
                this.card_type_options = element.options;
              } else if(element.dict_id === 3) {
                // 卡状态
                // this.status_options = element.options;
              }
            });
          }
        }
      });
      this.status_options = [
        { value: 0, label: "可测试" },
        { value: 1, label: "库存" },
        { value: 2, label: "待激活" },
        { value: 3, label: "已激活" },
        { value: 4, label: "已停机" },
        { value: 5, label: "预销户" },
        { value: 6, label: "已销户" },
      ];
    },
    LoadPkgSourceOptions: function() {
      Api.LoadPkgSourceOptions({}).then(res => {
        if(res && res.code === 200 && res.data) {
          if(res.data.pkg_options) {
            this.pkg_list = res.data.pkg_options;
            this.pkg_list.forEach(item => {
              this.package_options.push({
                  value: item.package_id,
                  label: item.package_name
                });
            });
          }
          if(res.data.source_options) {
            this.source_list = res.data.source_options;
            this.source_list.forEach(item => {
              this.source_options.push({
                  value: item.source_id,
                  label: item.source_name
                });
            });
          }
        }
      });
    },
    resetFormSimInfo: function() {
      this.formSimInfo = {
        sim_id: 0,
        iccid: "",
        sim: "",
        operator_type: 0,
        operator_type_text: "请选择",
        card_type: 0,
        card_type_text: "请选择",
        hold_id: 0,
        hold_name: "",
        package_id: null,
        package_text: "请选择",
        imsi: null,
        source_id: null,
        source_text: "请选择",
        quiet_period: null,
        shipped_date: null,
        remark: null
      };
    },
    handleFilterStatus: function(cmd) {
      this.filter_status = cmd.label;
      this.formInline.status = parseInt(cmd.value);
      this.SearchSimList();
    },
    SearchSimList: function() {
      this.loadingTableData = true;
      this.formInline.hold_id = this.selectHoldId;
      this.tableData = [];

      this.formInline.page_index = this.pagging.current_page;
      this.formInline.page_size = this.pagging.pager_size;
      Api.SimList(this.formInline).then(res => {
        this.loadingTableData = false;
        if(!res)
          return;
        if(res.code === 200 && res.data) {
          this.pagging.records_total = res.total;
          this.tableData = res.data;
        } else {
          this.$message.info("暂无数据");
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    openCardDetailDrawer: function(row, column, event) {
      if(column.label === "操作")
        return;
      this.drawer = true;
      this.drActiveName = 'detail';
      Api.SimDetail2({ sim_id: row.sim_id }).then(res => {
        if(res && res.code === 200 && res.data) {
          this.simCardDetailForm = {
            sim_id: row.sim_id,
            iccid: res.data.iccid,
            sim: res.data.sim,
            imsi: res.data.imsi,
            source_id: res.data.source_id,
            operator_type: res.data.operator_type && res.data.operator_type > 0 ? this.operator_type_options.find(x => x.value == res.data.operator_type).label : "",
            card_type: res.data.card_type && res.data.card_type > 0 ? this.card_type_options.find(x => x.value == res.data.card_type).label : "",
            package: res.data.package_name,
            quiet_period: res.data.quiet_period,
            shipped_date: res.data.shipped_date,
            remark: res.data.remark,
            status: res.data.status,
            active_time: res.data.active_time,
            expired_time: res.data.expire_time,
            realName_type: res.data.realname_type,
            realName_status: res.data.realname_status,
            month_usage: res.data.month_usage,
            amount_usage: res.data.amount_usage
          };

          let surplus = this.simCardDetailForm.amount_usage - this.simCardDetailForm.month_usage;
          this.$nextTick(() => {
            this.loadUsageCharts(this.simCardDetailForm.month_usage, surplus);
          });
        } else {
          console.log(`获取sim卡资料没返回数据${res ? res.msg : ''}`);
          // this.$message.error(`出错了！${res ? res.msg : ''}`);
        }
      });
    },
    handleDrTabClick: function(tab, event) {
      console.log(tab.name);
      if(tab.name == "renewal-pkg") {
        // 加载可续套餐列表
        if(this.simCardDetailForm.source_id === 1) {
            this.loadRenewablePkgList(this.simCardDetailForm.iccid);
        } else if(this.simCardDetailForm.source_id === 2) {
            this.loadSimbossRenewablePkgList(this.simCardDetailForm.iccid);
        }
      }
    },
    openBatchSearch: function() {
      this.batchSearchDialogVisible = true;
    },
    batchSearch: function() {
      const list = this.splitByCommaOrNewline(this.inputMultiple);
      if(list.length === 0) {
        this.$message.error('请输入ICCID号');
        return;
      }
      this.formInline.batch_iccid = list;
      this.SearchSimList();
      this.batchSearchDialogVisible = false;
    },
    exportList: function() {
      // 导出全部
      var argdata = {
        search_type: this.formInline.search_type,
        key: this.formInline.key,
        ContainChildren: true,
        HoldID: this.selectHoldId
      };
      Api.Device_ExportList(argdata).then(res => {
        if(!res)
          return;
        if(res.code != 200) {
          this.$message.error(res.msg);
        }
        if(res.data) {
          var hostStr = window.location.host;
          var my_request = hostStr.indexOf('gps881.com') > -1 ?
              `https://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}` :
              `http://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}`;
          window.open(my_request);
        } else {
          this.$message.error('无数据导出！');
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    handleNodeClick: function(data) {
      this.selectHoldId = data.id;
      this.selectedHoldName = data.label;
      this.SearchSimList();
    },
    handleAllocateNodeClick: function(data) {
      this.formAllocate.to_hold_id = data.id;
      this.formAllocate.newHoldName = data.label;
    },
    handleSelectOperatorType: function(cmd) {
      this.formSimInfo.operator_type_text = cmd.label;
      this.formSimInfo.operator_type = cmd.value;
    },
    handleSelectCardType: function(cmd) {
      this.formSimInfo.card_type_text = cmd.label;
      this.formSimInfo.card_type = cmd.value;
    },
    handleSelectPackage: function(cmd) {
      this.formSimInfo.package_text = cmd.label;
      this.formSimInfo.package_id = cmd.value;
    },
    handleSelectSource: function(cmd) {
      this.formSimInfo.source_text = cmd.label;
      this.formSimInfo.source_id = cmd.value;
    },
    modifySimWin: function(id) {
      this.resetFormSimInfo();
      this.formSimInfo.sim_id = id;
      this.formSimInfo.hold_id = this.selectHoldId;
      this.formSimInfo.hold_name = this.selectedHoldName;
      this.dialogFormVisible = true;
      this.loadSimDetail(id);
    },
    loadSimDetail: function(sim_id) {
      Api.SimDetail({ sim_id: sim_id }).then(res => {
        if(res && res.code === 200 && res.data) {
          this.formSimInfo.hold_id = res.data.hold_id;
          this.formSimInfo.hold_name = res.data.hold_name;
          this.formSimInfo.iccid = res.data.iccid;
          this.formSimInfo.sim = res.data.sim;
          this.formSimInfo.operator_type = res.data.operator_type;
          this.formSimInfo.operator_type_text = res.data.operator_type && res.data.operator_type > 0 ? this.operator_type_options.find(x => x.value == res.data.operator_type).label : "";
          this.formSimInfo.card_type = res.data.card_type;
          this.formSimInfo.card_type_text = res.data.card_type && res.data.card_type > 0 ? this.card_type_options.find(x => x.value == res.data.card_type).label : "";
          this.formSimInfo.package_id = res.data.package_id;
          this.formSimInfo.package_text = res.data.package_id && res.data.package_id > 0 ? this.package_options.find(x => x.value == res.data.package_id).label : "";
          this.formSimInfo.imsi = res.data.imsi;
          this.formSimInfo.source_id = res.data.source_id;
          this.formSimInfo.source_text = res.data.source_id && res.data.source_id > 0 ? this.source_options.find(x => x.value == res.data.source_id).label : "";
          this.formSimInfo.quiet_period = res.data.quiet_period;
          this.formSimInfo.shipped_date = res.data.shipped_date;
          this.formSimInfo.remark = res.data.remark;
        } else {
          console.log(`获取sim卡资料没返回数据${res ? res.msg : ''}`);
          this.$message.error(`出错了！${res ? res.msg : ''}`);
        }
      });
    },
    removeSim: function(id) {
      var masters = [];
      if(id == 0) {
        if(this.multipleSelection.length > 0) {
          this.multipleSelection.forEach(s => {
            masters.push(s.sim_id);
          });
        } else {
          this.$message({
              message: '请选择卡',
              type: 'warning'
          });
          return;
        }
      } else {
        masters.push(id);
      }
      this.$confirm('此操作将删除该卡信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
         var argdata = {
            sim_ids: masters
          };
          Api.RemoveSim(argdata).then(res => {
            if(res.code === 200) {
                  this.$message({
                      message: '已删除！',
                      type: 'success'
                  });
                  this.SearchSimList();
              } else {
                  this.$message({
                      message: '删除失败！',
                      type: 'warning'
                  });
              }
          });
      });
    },
    InsyncSingleCard: function() {
      // 同步单张卡数据
      Api.InsyncSingleCard({ sim_id: this.formSimInfo.sim_id }).then(res => {
        if(res.code === 200) {
          this.$message({
              message: '同步成功！',
              type: 'success'
          });
          this.loadSimDetail(this.formSimInfo.sim_id);
        }
      });
    },
    addOpenWin: function() {
      this.formSimInfo.sim_id = 0;
      this.formSimInfo.hold_id = this.selectHoldId;
      this.formSimInfo.hold_name = this.selectedHoldName;
      this.dialogFormVisible = true;
    },
    allocate: function() {
      if(this.multipleSelection.length === 0) {
        this.$message.error('请选择要操作的卡！');
        return;
      }
      var iccid_arr = [];
      var simid_arr = [];
      this.multipleSelection.forEach(item => {
        simid_arr.push(item.sim_id);
        iccid_arr.push(item.iccid);
      });
      this.formAllocate.sim_ids = simid_arr;
      this.formAllocate.iccid = iccid_arr.join(",");
      this.allocateDialogVisible = true;
    },
    activeCard: function() {
      if(this.multipleSelection.length === 0) {
        this.$message.error('请选择要操作的卡！');
        return;
      }

      var simid_arr = [];
      this.multipleSelection.forEach(item => {
        simid_arr.push(item.sim_id);
      });
      this.changeSimStatus(simid_arr, 3);
    },
    deactivateCard: function() {
      if(this.multipleSelection.length === 0) {
        this.$message.error('请选择要操作的卡！');
        return;
      }

      var simid_arr = [];
      this.multipleSelection.forEach(item => {
        simid_arr.push(item.sim_id);
      });
      this.$confirm('将停用该卡, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        this.changeSimStatus(simid_arr, 4);
      });
    },
    changeSimStatus: function(sim_id_arr, status) {
      var argdata = {
        sim_ids: sim_id_arr,
        status: status
      };
      Api.ChangeSimStatus(argdata).then(res => {
        if(res && res.code === 200) {
          this.$message({
            message: '操作成功！指令已下发，请稍后刷新设备状态',
            type: 'success'
          });
        } else {
          this.$message.error('操作失败！');
        }
      });
    },
    rechargePkg: function(pkg_id, pkg_name, price) {
      // 续购
      this.$confirm(`确认要续购套餐 ${pkg_name}, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        if(this.simCardDetailForm.source_id === 1) {
          var argdata = {
            sim_id: this.simCardDetailForm.sim_id,
            pkg_id: pkg_id,
            pkg_name: pkg_name,
            recharge_price: price ?? 1
          };
          Api.CardRechargePkg(argdata).then(res => {
            if(res && res.code === 200) {
              this.$message({
                message: '操作成功！已提交续购申请',
                type: 'success'
              });
            } else {
              this.$message.error('操作失败！');
            }
          });
        } else if(this.simCardDetailForm.source_id === 2) {
          var argdata = {
            sim_id: this.simCardDetailForm.sim_id,
            ratePlanId: pkg_id,
            pkg_name: pkg_name
          };
          Api.SimbossRechargePkg(argdata).then(res => {
            if(res && res.code === 200) {
              this.$message({
                message: '操作成功！已提交续购申请',
                type: 'success'
              });
            } else {
              this.$message.error('操作失败！');
            }
          });
        }
      });
    },
    insyncCards: function() {
      // 同步多张卡
      var simid_arr1 = [], simid_arr2 = [];
      this.multipleSelection.forEach(item => {
        if(item.source_id === 1) {
          simid_arr1.push(item.sim_id);
        } else if(item.source_id === 2) {
          simid_arr2.push(item.sim_id);
        }
      });
      if(simid_arr1.length === 0 && simid_arr2.length === 0) {
          this.$message.error('请选择卡！');
          return;
      }

      if(simid_arr1.length > 0) {
        var argdata = {
          sim_ids: simid_arr1
        };
        Api.InsyncMultipleCards(argdata).then(res => {
            if(res && res.code === 200) {
              this.$message({
                message: '同步成功！',
                type: 'success'
              });
              this.SearchSimList();
            } else {
              this.$message.error(`提交失败！${res ? res.msg : ''}`);
            }
        });
      }

      if(simid_arr2.length > 0) {
        var argdata = {
          sim_ids: simid_arr2
        };
        Api.InsyncMultipleSimBossCards(argdata).then(res => {
            if(res && res.code === 200) {
              this.$message({
                message: '同步成功！',
                type: 'success'
              });
              this.SearchSimList();
            } else {
              this.$message.error(`提交失败！${res ? res.msg : ''}`);
            }
        });
      }
      
    },
    handlePaneClick: function(tab) {
    },
    addSimInfo: function(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveBtnDisableds[0] = true;
          if(this.formSimInfo.card_type) {
            this.formSimInfo.card_type = /^-?\d+$/.test(this.formSimInfo.card_type) ? 
                this.formSimInfo.card_type :
                this.card_type_options.find(x => x.label == this.formSimInfo.card_type).value;
          }
          Api.AddSim(this.formSimInfo).then(res => {
            this.saveBtnDisableds[0] = false;
            if(res && res.code === 200) {
              this.$message({
                message: '恭喜你，提交成功！',
                type: 'success'
              });
              this.resetFormSimInfo();
              this.dialogFormVisible = false;
              this.SearchSimList();
            } else {
              this.$message.error(`提交失败！${res ? res.msg : ''}`);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitAllocate: function() {
        if(this.formAllocate.sim_ids.length === 0) {
            this.$message.error('请选择卡！');
            return;
        }
        if(this.formAllocate.to_hold_id === 0) {
            this.$message.error('请选择组织！');
            return;
        }

        Api.AllocateSims(this.formAllocate).then(res => {
          if(res && res.code === 200) {
              // 分配成功
              this.$message({
                  message: '分配成功！',
                  type: 'success'
              });

              this.allocateDialogVisible = false;
              this.formAllocate.sim_ids = [];
              this.formAllocate.to_hold_id = 0;
              this.formAllocate.iccid = "";
              this.SearchSimList();
          }
      });
    },
    loadUsageCharts: function(usage, surplus) {
      // 通过 ref 获取 DOM 元素
      const chartDom = this.$refs.pieChart;
      // 初始化 ECharts 实例
      this.chartInstance = echarts.init(chartDom);
      // 4. 配置饼图的 option
      const option = {
        title: {
          text: '月使用流量',
          left: 'center' // 标题居中
        },
        tooltip: {
          trigger: 'item', // 触发类型：数据项图形触发
          formatter: '{a} <br/>{b} : {c} ({d}%)' // 提示框内容格式
        },
        legend: {
          orient: 'vertical', // 图例垂直排列
          left: 'left', // 图例靠左
          data: ['已使用流量', '剩余流量']
        },
        series: [
          {
            name: '月使用流量',
            type: 'pie', // 图表类型：饼图
            radius: '50%', // 饼图半径
            center: ['50%', '60%'], // 饼图位置（水平居中，垂直偏下）
            data: [
              { value: usage, name: '已使用流量' },
              { value: surplus, name: '剩余流量' }
            ],
            label: {
              show: true,
              formatter: '{b}\n{c} MB',  // name 换行显示数值
              fontSize: 12,
              color: '#333'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      // 5. 使用刚指定的配置项显示图表
      this.chartInstance.setOption(option);
    },
    loadRenewablePkgList: function(iccid) {
      var argdata = {iccid: iccid};

      this.renewablePkgTable = [];
      // 查询可续套餐
      Api.GetRenewablePkgList(argdata).then(res => {
        if(res && res.code === 200) {
          this.renewablePkgTable = res.data;
        }
      });

      this.purchasedPkgTable = [];
      // 查询已续购套餐
      Api.GetPurchasedPkgList(argdata).then(res => {
        if(res && res.code === 200) {
          this.purchasedPkgTable = res.data;
        }
      });
    },
    loadSimbossRenewablePkgList: function(iccid) {
      var argdata = {iccid: iccid};

      this.renewablePkgTable = [];
      // 查询可续套餐
      Api.SimbossRenewablePkgList(argdata).then(res => {
        if(res && res.code === 200) {
          /*
            {
              "success": true,
              "ratePlanId": 1410,
              "name": "300.0M/月",
              "type": "monthly",
              "dataVolume": 300.0,
              "description": "300.0M/月",
              "maxRechargePeriod": 20
            }
          */
          res.data.forEach(item => {
            this.renewablePkgTable.push({
              id: item.ratePlanId,
              pkgNameCustom: item.name,
              flowGear: `${item.dataVolume}MB`,
              pkgTypeStr: item.type,
              pkgValidity: 1,
              pkgStatus: 0,
            });
          });
        }
      });

      this.purchasedPkgTable = [];
      // 查询已续购套餐 
      Api.SimBossPurchasedPkgList(argdata).then(res => {
        if(res && res.code === 200) {
          res.data.forEach(item => {
            this.purchasedPkgTable.push({
              pkgId: 1,
              pkg: item.volumePlanName,
              pkgTypeStr: item.volumePlanType,
              gprsTotal: item.dataVolume,
              description: `${item.orderName}-${item.sequence}`,
              createTime: item.createTime
            });
          });
        }
      });
    },
    renewalPkgDia: function() {
      var masters = [], iccid_arr = [];
      var notSupported = false;
      if(this.multipleSelection.length > 0) {
        this.multipleSelection.forEach(s => {
          masters.push(s.sim_id);
          iccid_arr.push(s.iccid);
          if(s.source_id !== 2) {
            notSupported = true;
          }
        });
      } else {
        this.$message({
            message: '请选择卡',
            type: 'warning'
        });
        return;
      }

      if(notSupported) {
        this.$message({
            message: '卡不支持续费',
            type: 'warning'
        });
        return;
      }

      var unit_price = 0.1;
      this.formRenwals.sim_ids = masters;
      this.formRenwals.iccids = iccid_arr.join(",");
      this.formRenwals.amount = masters.length * unit_price;
      this.renewalsDialogVisible = true;

      // 查询卡可续套餐
      this.purchasedPkgItems = [];
      var argdata = {iccid: iccid_arr[0]};
      Api.SimbossRenewablePkgList(argdata).then(res => {
        if(res && res.code === 200 && res.data) {
          res.data.forEach(item => {
            this.purchasedPkgItems.push({
              value: item.ratePlanId,
              label: item.name
            });
          });
        }
      });
    },
    handleRenewal: function() {
      // 续费充值
      if(this.formRenwals.radioPkg < 1) {
        this.$message({
            message: '请选择套餐',
            type: 'warning'
        });
        return;
      }

      if(this.formRenwals.amount > 0) {
        // 打开充值
        var pkgName = "";
        for(var i=0; i<this.purchasedPkgItems.length; i++) {
          if(this.purchasedPkgItems[i].value === this.formRenwals.radioPkg) {
            pkgName = this.purchasedPkgItems[i].label;
            break;
          }
        }
        var argdata = {
          sim_id_list: this.formRenwals.sim_ids,
          pkg_id: 0,
          merchant_pkg_id: this.formRenwals.radioPkg,
          merchant_pkg_name: pkgName,
          amount: this.formRenwals.amount,
          unit_price: 10,
          cycle_month: 1,
          pay_method: this.formRenwals.radioPaytype == '1' ? 'alipay' : 'wechatpay'
        };
        Api.BuildRenewalsOrder(argdata).then(res => {
          if(res) {
            const blob = new Blob([res], { type: 'text/html' });
            const url = URL.createObjectURL(blob);
            const newWindow = window.open(url, '_blank');
            // 清理（可选，稍后释放）
            if (newWindow) {
              newWindow.onload = () => {
                URL.revokeObjectURL(url);
              }
            }
          }
        });
      } else {
        this.$message({
            message: '充值价格未配置',
            type: 'warning'
        });
        return;
      }
    },
    batchSetTag1: function() {
      const list = this.splitByCommaOrNewline(this.inputMultiple);
      if(list.length === 0) {
        this.$message.error('请输入ICCID号');
        return;
      }
      var argdata = {
        iccidList: list,
        tag: this.tag1Value
      }
      Api.BatchSetTag1(argdata).then(res => {
        if(res && res.code === 200) {
          this.$message({
              message: '设置成功！',
              type: 'success'
          })
          this.SearchSimList();
        } else {
          this.$message({
              message: '设置失败！',
              type: 'warning'
          })
        }
        this.tag1DialogVisible = false;
      })
    },
    batchSetTag2: function() {
      const list = this.splitByCommaOrNewline(this.inputMultiple);
      if(list.length === 0) {
        this.$message.error('请输入ICCID号');
        return;
      }
      var argdata = {
        iccidList: list,
        tag: this.tag2Value
      }
      Api.BatchSetTag2(argdata).then(res => {
        if(res && res.code === 200) {
          this.$message({
              message: '设置成功！',
              type: 'success'
          })
          this.SearchSimList();
        } else {
          this.$message({
              message: '设置失败！',
              type: 'warning'
          })
        }
        this.tag2DialogVisible = false;
      })
    }
  },
  mounted() {
    var h = document.body.clientHeight - 240;
    var h2 = document.body.clientHeight - 240;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
        // 或者使用Vue.set来响应式地更新样式
        // this.$set(table.$el.style, 'height', '300px');
      }
      const tree = this.$refs.getTreeInstance;
      if(tree) {
        tree.$el.style.height = h2 + 'px';
      }
    });

    this.loadHoldTree();
    this.loadDictionOptions();
    this.LoadPkgSourceOptions();
    this.SearchSimList();
  }
}
</script>

<style scoped>
.tree-divBox {
  padding-top: 10px;
  padding-left: 10px;
  width: 95%;
  min-height: 500px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
::v-deep .sanmuui-select .el-select-dropdown__wrap {
  max-height: 300px; /* 或你想要的任意高度 */
}
.in-sync-b {
  margin-left: 10px;
}
.dr-container {
  padding-left: 10px;
}
.dr-card-detail {
  padding: 10px;
}
.dr-card-label {
  padding-top: 12px;
  padding-bottom: 5px;
  color: #999999;
}
</style>